/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable no-shadow */
/* eslint-disable import/extensions */
import React, { useEffect } from 'react';
import { useTranslation } from 'next-i18next';

import { makeStyles } from '@material-ui/core/styles';

import BottomNavigation from '@material-ui/core/BottomNavigation';
import BottomNavigationAction from '@material-ui/core/BottomNavigationAction';

import { useRouter } from 'next/router';
import { NAVIGATION_ITEMS } from '@/constants';

const useStyles = makeStyles(() => ({
  bottomNavRoot: {
    width: '100%',
    position: 'fixed',
    bottom: 0,
    zIndex: 800,
  },
  label: {
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
}));

interface Props {
  enableBottomNavigation: boolean
}

const BottomNavigationWrapper: React.FC<Props> = (
  { enableBottomNavigation }: Props,
) => {
  const classes = useStyles();

  // bottom navigation
  // const { pathname } = useLocation();
  const { pathname, push } = useRouter();
  const [value, setValue] = React.useState(0);

  useEffect(() => {
    if (pathname === '/') {
      setValue(0);
    } else {
      setValue(NAVIGATION_ITEMS.map((x) => x.slug).findIndex((x) => (
        pathname.startsWith(x) && x !== '/'
      )) || 0);
    }
  }, [pathname]);

  const onLink = (href: string) => {
    push(href);
  };

  // i18n
  const { t } = useTranslation('common');
  return (
    <>
      {enableBottomNavigation
      && (
      <BottomNavigation
        value={value}
        onChange={(event, newValue) => {
          setValue(newValue);
        }}
        showLabels
        className={classes.bottomNavRoot}
      >
        {NAVIGATION_ITEMS.filter((x) => x.showsIn.includes('BOTTOM_NAV')).map((item) => (
          <BottomNavigationAction
            label={t(`appbar.navItems.${item.i18nkey}` as const)}
            icon={item.icon}
            onClick={() => onLink(item.slug)}
            key={item.i18nkey}
            // href={item.slug}
          />
        ))}
      </BottomNavigation>
      )}
    </>
  );
};

export default BottomNavigationWrapper;
